module.exports = __webpack_public_path__ + "img/bannerimg03.bf840819.png";